export default "__VITE_ASSET__CL4pap3M__"